var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcnDashboard = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_005-dashboard",
    transform: "translate(0 -52.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(0 52.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st0",
    d: "M42.9 12.8c-.7-.7-1.7-.8-2.5-.2-3 2-17.8 12.1-19.3 13.7-2.3 2.3-2.3 6.1 0 8.4s6.1 2.3 8.4 0C31 33 41.1 18.2 43.1 15.3c.6-.8.5-1.9-.2-2.5zm-16.3 19c-.8.8-2 .8-2.8 0-.8-.8-.8-2 0-2.8.6-.6 4.8-3.6 10-7.2-3.6 5.2-6.5 9.4-7.2 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st0",
    d: "M9.1 39.6l-2.4 1.2c-3.1-5.5-3.6-12-1.3-17.9l2.8 1.3c1 .5 2.2.1 2.6-.9s.1-2.2-.9-2.6l-2.8-1.3c3.5-5.7 9.5-9.5 16.2-10.1v3c0 1.1.9 2 2 2s2-.9 2-2v-3c2.3.1 4.6.7 6.7 1.7 1 .4 2.2 0 2.6-1s0-2.2-1-2.6C22.9 1.7 8 7.3 2.2 20c-3.6 8-2.8 17.2 2 24.5.5.8 1.6 1.1 2.5.7l4-2c1-.5 1.4-1.7.9-2.6-.3-1.1-1.5-1.5-2.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M48.3 20.1c-.4-1-1.6-1.4-2.6-1-1 .4-1.4 1.6-1 2.6 2.8 6.1 2.5 13.2-.8 19.1l-2.5-1.2c-1-.5-2.2-.1-2.6.9-.5 1-.1 2.2.9 2.6l4.1 2c.9.4 1.9.1 2.5-.7 4.8-7.2 5.5-16.4 2-24.3z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn_dashboard.6ac11ce2.svg";
export { ForwardRef as ReactComponent };